function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M142.09,14.85C118.19-9.28,68.15-2.82,49.72,25.71c-29.22,45.24-9.22,125.87,99.13,126.72,120.41.95,97.08-94.96,62.96-117.4-24.33-16-46.58,3.18-69.72-20.19Z",
    style: {
      fill: "#1c2f35",
      opacity: 0.08,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 29.14,
    width: 194.16,
    height: 97.28,
    rx: 2.6,
    ry: 2.6,
    style: {
      fill: "#fff",
      stroke: "#6b6b6b",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 38.91,
    x2: 120,
    y2: 86.73,
    style: {
      fill: "none",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 107.34,
    x2: 120,
    y2: 114.98,
    style: {
      fill: "none",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 93.21,
    x2: 120,
    y2: 100.85,
    style: {
      fill: "none",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.25,76.51l10.04,10.04s0,0,0,0,0,0,0,0l10.65,10.65c.2.2.51.2.71,0s.2-.51,0-.71l-10.31-10.31,4.46-4.46c3.03-3.03,7.96-3.03,10.98,0l13.19,13.52v-39.27c0-2.21-1.79-4-4-4h-64c-2.21,0-4,1.79-4,4v40.59l21.27-20.08c3.03-3.03,7.96-3.03,10.98,0Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,104h64c2.21,0,4-1.79,4-4v-4.73l-13.19-13.52c-3.02-3.02-7.95-3.02-10.98,0l-4.46,4.46,10.31,10.31c.2.2.2.51,0,.71s-.51.2-.71,0l-10.65-10.65s0,0,0,0,0,0,0,0l-10.04-10.04c-3.03-3.03-7.96-3.03-10.98,0l-21.27,20.08v3.41c0,2.21,1.79,4,4,4Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,104h64c2.21,0,4-1.79,4-4v-4.73l-13.19-13.52c-3.02-3.02-7.95-3.02-10.98,0l-4.46,4.46,10.31,10.31c.2.2.2.51,0,.71s-.51.2-.71,0l-10.65-10.65s0,0,0,0,0,0,0,0l-10.04-10.04c-3.03-3.03-7.96-3.03-10.98,0l-21.27,20.08v3.41c0,2.21,1.79,4,4,4Z",
    style: {
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.76,
    cy: 64.15,
    r: 5.91,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,40h-26.86c-1.85,0-3.36,1.5-3.36,3.36v26.86c0,1.85,1.5,3.36,3.36,3.36h26.86c1.85,0,3.36-1.5,3.36-3.36v-26.86c0-1.85-1.5-3.36-3.36-3.36Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.36,73.57h26.86c1.85,0,3.36-1.5,3.36-3.36v-4.77l-5.83-5.97c-1.69-1.69-4.45-1.69-6.14,0l-2.5,2.5,5.77,5.77c.11.11.11.29,0,.4s-.29.11-.4,0l-5.96-5.96s0,0,0,0,0,0,0,0l-5.62-5.62c-1.69-1.69-4.45-1.69-6.15,0l-6.74,6.36v7.31c0,1.85,1.5,3.36,3.36,3.36Z",
    style: {
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.04,
    cy: 49.62,
    r: 3.3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21,40h-26.86c-1.85,0-3.36,1.5-3.36,3.36v26.86c0,1.85,1.5,3.36,3.36,3.36h26.86c1.85,0,3.36-1.5,3.36-3.36v-26.86c0-1.85-1.5-3.36-3.36-3.36Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36,73.57h26.86c1.85,0,3.36-1.5,3.36-3.36v-4.77l-5.83-5.97c-1.69-1.69-4.45-1.69-6.14,0l-2.5,2.5,5.77,5.77c.11.11.11.29,0,.4s-.29.11-.4,0l-5.96-5.96s0,0,0,0,0,0,0,0l-5.62-5.62c-1.69-1.69-4.45-1.69-6.15,0l-6.74,6.36v7.31c0,1.85,1.5,3.36,3.36,3.36Z",
    style: {
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.04,
    cy: 49.62,
    r: 3.3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,83h-26.86c-1.85,0-3.36,1.5-3.36,3.36v26.86c0,1.85,1.5,3.36,3.36,3.36h26.86c1.85,0,3.36-1.5,3.36-3.36v-26.86c0-1.85-1.5-3.36-3.36-3.36Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.36,116.57h26.86c1.85,0,3.36-1.5,3.36-3.36v-4.77l-5.83-5.97c-1.69-1.69-4.45-1.69-6.14,0l-2.5,2.5,5.77,5.77c.11.11.11.29,0,.4s-.29.11-.4,0l-5.96-5.96s0,0,0,0,0,0,0,0l-5.62-5.62c-1.69-1.69-4.45-1.69-6.15,0l-6.74,6.36v7.31c0,1.85,1.5,3.36,3.36,3.36Z",
    style: {
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.04,
    cy: 92.62,
    r: 3.3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21,83h-26.86c-1.85,0-3.36,1.5-3.36,3.36v26.86c0,1.85,1.5,3.36,3.36,3.36h26.86c1.85,0,3.36-1.5,3.36-3.36v-26.86c0-1.85-1.5-3.36-3.36-3.36Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36,116.57h26.86c1.85,0,3.36-1.5,3.36-3.36v-4.77l-5.83-5.97c-1.69-1.69-4.45-1.69-6.14,0l-2.5,2.5,5.77,5.77c.11.11.11.29,0,.4s-.29.11-.4,0l-5.96-5.96s0,0,0,0,0,0,0,0l-5.62-5.62c-1.69-1.69-4.45-1.69-6.15,0l-6.74,6.36v7.31c0,1.85,1.5,3.36,3.36,3.36Z",
    style: {
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.04,
    cy: 92.62,
    r: 3.3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoFlow);
export default __webpack_public_path__ + "static/media/auto-flow.518a21ab9323571409e7b0235855b00e.svg";
export { ForwardRef as ReactComponent };